/*       */

import { gql } from '@apollo/client';

export default gql`
    query resourcePermissionQuery($type: String!, $id: ID!) {
        result: resourcePermission(type: $type, id: $id)
    }
`;
